import { inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '../environments/environment';

const NEW_RELIC_LOADER_SRC =
  'https://js-agent.newrelic.com/nr-loader-spa-1.312.1.min.js';
const NEW_RELIC_SHARED_CONFIG = {
  accountID: environment.newrelicAccountId,
  trustKey: environment.newrelicTrustKey,
  licenseKey: environment.newrelicLicenseKey,
  beacon: 'bam.eu01.nr-data.net',
  errorBeacon: 'bam.eu01.nr-data.net'
};

export function injectNewRelicBrowserAgent() {
  const document = inject(DOCUMENT);
  const windowRef = document.defaultView as
    | (Window & { NREUM?: { initializedAgents?: Record<string, unknown> } })
    | null;

  if (!windowRef) {
    return;
  }

  if (document.querySelector(`script[src="${NEW_RELIC_LOADER_SRC}"]`)) {
    return;
  }

  const nrConfig = {
    agentID: environment.newrelicAgentId,
    applicationID: environment.newrelicApplicationId
  };

  const configScript = document.createElement('script');
  configScript.type = 'text/javascript';
  configScript.text = [
    ';window.NREUM||(NREUM={});',
    `NREUM.init=${JSON.stringify({
      distributed_tracing: { enabled: true },
      performance: { capture_measures: true },
      browser_consent_mode: { enabled: false },
      privacy: { cookies_enabled: true },
      ajax: {
        deny_list: ['bam.eu01.nr-data.net'],
        capture_payloads: 'none'
      }
    })};`,
    `NREUM.loader_config=${JSON.stringify({
      accountID: NEW_RELIC_SHARED_CONFIG.accountID,
      trustKey: NEW_RELIC_SHARED_CONFIG.trustKey,
      agentID: nrConfig.agentID,
      licenseKey: NEW_RELIC_SHARED_CONFIG.licenseKey,
      applicationID: nrConfig.applicationID
    })};`,
    `NREUM.info=${JSON.stringify({
      beacon: NEW_RELIC_SHARED_CONFIG.beacon,
      errorBeacon: NEW_RELIC_SHARED_CONFIG.errorBeacon,
      licenseKey: NEW_RELIC_SHARED_CONFIG.licenseKey,
      applicationID: nrConfig.applicationID,
      sa: 1
    })};`
  ].join('');

  const loaderScript = document.createElement('script');
  loaderScript.type = 'text/javascript';
  loaderScript.src = NEW_RELIC_LOADER_SRC;
  loaderScript.crossOrigin = 'anonymous';

  document.head.appendChild(configScript);
  document.head.appendChild(loaderScript);
}